import { Text } from "@chakra-ui/react";

export const SalesCannotCloseSaleWithoutPharmacyIdError = () => {
  return <Text>Pharmacie non définie</Text>;
};
